import { Component, h, Element, Method } from '@stencil/core';
import { getElementAttributes } from '../../utils/utils';

@Component({
  tag: 'rentware-checkout',
  shadow: true,
})
export class RentwareCheckout {
  @Element() el;
  container: HTMLElement;

  @Method()
  async updateAccount(accessToken: string, onSuccess = () => null) {
    (this.container as any)?.updateAccount(accessToken, onSuccess);
  }

  render() {
    const properties = getElementAttributes(this.el.attributes, { class: true, ref: true, style: true });

    return <rtr-checkout {...properties} ref={el => (this.container = el as HTMLElement)} />;
  }
}
